import type { WeaponDef } from './types/GameState.js';

// ─── Tank Weapons (13 total, players pick 5 for loadout) ───

export const TANK_WEAPONS: WeaponDef[] = [
  {
    id: 'single_shot',
    name: 'Single Shot',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 80,
    gravityMultiplier: 1,
    blastRadius: 4,
    damage: 25,
    splashDamage: 10,
    craterRadius: 3,
    craterDepth: 2,
    cooldownMs: 2000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: '',
    description: 'Basic projectile with a clean parabolic arc. Fast reload.',
  },
  {
    id: 'big_shot',
    name: 'Big Shot',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 60,
    gravityMultiplier: 1,
    blastRadius: 8,
    damage: 45,
    splashDamage: 20,
    craterRadius: 8,
    craterDepth: 6,
    cooldownMs: 4000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: '',
    description: 'Larger, slower projectile. More blast, more crater.',
  },
  {
    id: 'nuke',
    name: 'Nuke',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 50,
    gravityMultiplier: 1,
    blastRadius: 20,
    damage: 80,
    splashDamage: 40,
    craterRadius: 20,
    craterDepth: 12,
    cooldownMs: 15000,
    magSize: 1,
    reloadMs: 0,
    burstCount: 1,
    special: '',
    description: 'Massive explosion. One per match. Mushroom cloud.',
  },
  {
    id: 'sniper',
    name: 'Sniper',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 200,
    gravityMultiplier: 0.3,
    blastRadius: 2,
    damage: 50,
    splashDamage: 5,
    craterRadius: 1,
    craterDepth: 1,
    cooldownMs: 3000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: '',
    description: 'Very fast projectile, minimal arc. Pinpoint accuracy.',
  },
  {
    id: 'shotgun',
    name: 'Shotgun',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 70,
    gravityMultiplier: 1,
    blastRadius: 3,
    damage: 10,
    splashDamage: 5,
    craterRadius: 2,
    craterDepth: 1,
    cooldownMs: 5000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 5,
    special: 'cluster',
    description: 'Fires 5 pellets in a spread cone. Devastating close range.',
  },
  {
    id: 'napalm',
    name: 'Napalm',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 65,
    gravityMultiplier: 1,
    blastRadius: 6,
    damage: 15,
    splashDamage: 5,
    craterRadius: 0,
    craterDepth: 0,
    cooldownMs: 6000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: 'napalm',
    description: 'Creates a fire zone that burns for 5 seconds. Area denial.',
  },
  {
    id: 'roller',
    name: 'Roller',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 70,
    gravityMultiplier: 1,
    blastRadius: 4,
    damage: 30,
    splashDamage: 15,
    craterRadius: 3,
    craterDepth: 2,
    cooldownMs: 3000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: 'roller',
    description: 'Rolls downhill along the terrain after impact.',
  },
  {
    id: 'bouncer',
    name: 'Bouncer',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 75,
    gravityMultiplier: 1,
    blastRadius: 3,
    damage: 20,
    splashDamage: 10,
    craterRadius: 2,
    craterDepth: 1,
    cooldownMs: 4000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: 'bouncing',
    description: 'Bounces 3 times off terrain, exploding each time.',
  },
  {
    id: 'digger',
    name: 'Digger',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 70,
    gravityMultiplier: 1,
    blastRadius: 1,
    damage: 30,
    splashDamage: 10,
    craterRadius: 4,
    craterDepth: 14,
    cooldownMs: 5000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: 'digger',
    description: 'Burrows underground then detonates. Creates a deep pit.',
  },
  {
    id: 'dirt_mover',
    name: 'Dirt Mover',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 65,
    gravityMultiplier: 1,
    blastRadius: 8,
    damage: 0,
    splashDamage: 0,
    craterRadius: 8,
    craterDepth: 7,
    cooldownMs: 3000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: 'dirt',
    description: 'Utility: adds terrain instead of removing it. Bury or build.',
  },
  {
    id: 'homing',
    name: 'Homing Missile',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 55,
    gravityMultiplier: 0.5,
    blastRadius: 5,
    damage: 35,
    splashDamage: 15,
    craterRadius: 3,
    craterDepth: 2,
    cooldownMs: 8000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: 'homing',
    description: 'Locks onto nearest enemy at peak arc. Can be blocked by terrain.',
  },
  {
    id: 'mirvs',
    name: 'MIRVs',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 60,
    gravityMultiplier: 1,
    blastRadius: 3,
    damage: 15,
    splashDamage: 8,
    craterRadius: 2,
    craterDepth: 1,
    cooldownMs: 10000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 6,
    special: 'cluster',
    description: 'Splits into 6 sub-munitions at peak altitude. Area saturation.',
  },
  {
    id: 'shockwave',
    name: 'Shockwave',
    category: 'tank',
    fireMode: 'single',
    projectileSpeed: 70,
    gravityMultiplier: 1,
    blastRadius: 15,
    damage: 20,
    splashDamage: 10,
    craterRadius: 16,
    craterDepth: 3,
    cooldownMs: 8000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: 'shockwave',
    description: 'Expanding ring explosion. Pushes tanks outward.',
  },
];

// ─── Infantry Weapons (always available, all 4) ───

export const INFANTRY_WEAPONS: WeaponDef[] = [
  {
    id: 'machine_gun',
    name: 'Machine Gun',
    category: 'infantry',
    fireMode: 'auto',
    projectileSpeed: 0, // hitscan
    gravityMultiplier: 0,
    blastRadius: 0,
    damage: 8,
    splashDamage: 0,
    craterRadius: 0,
    craterDepth: 0,
    cooldownMs: Math.round(60000 / 550), // 550 RPM ≈ 109ms
    magSize: 100,
    reloadMs: 4500,
    burstCount: 1,
    special: '',
    description: 'High rate of fire, high spread. Area suppression.',
  },
  {
    id: 'assault_rifle',
    name: 'Assault Rifle',
    category: 'infantry',
    fireMode: 'auto',
    projectileSpeed: 0, // hitscan
    gravityMultiplier: 0,
    blastRadius: 0,
    damage: 12,
    splashDamage: 0,
    craterRadius: 0,
    craterDepth: 0,
    cooldownMs: Math.round(60000 / 700), // 700 RPM ≈ 86ms
    magSize: 30,
    reloadMs: 2500,
    burstCount: 1,
    special: '',
    description: 'Versatile all-rounder. Accurate, good damage.',
  },
  {
    id: 'pistol',
    name: 'Pistol',
    category: 'infantry',
    fireMode: 'single',
    projectileSpeed: 0, // hitscan
    gravityMultiplier: 0,
    blastRadius: 0,
    damage: 18,
    splashDamage: 0,
    craterRadius: 0,
    craterDepth: 0,
    cooldownMs: 200, // ~300 RPM max
    magSize: 7,
    reloadMs: 1500,
    burstCount: 1,
    special: '',
    description: 'Quick-draw sidearm. High damage per shot, rewards accuracy.',
  },
  {
    id: 'bazooka',
    name: 'Bazooka',
    category: 'infantry',
    fireMode: 'single',
    projectileSpeed: 60,
    gravityMultiplier: 0.3,
    blastRadius: 5,
    damage: 250, // one-shots tanks (200 HP)
    splashDamage: 40, // infantry splash damage
    craterRadius: 5,
    craterDepth: 4,
    cooldownMs: 8000,
    magSize: -1,
    reloadMs: 0,
    burstCount: 1,
    special: '',
    description: 'Anti-tank rocket. One-shots tanks. 8 second cooldown. Slow projectile.',
  },
];

// ─── All weapons map for quick lookup ───

export const ALL_WEAPONS: Map<string, WeaponDef> = new Map(
  [...TANK_WEAPONS, ...INFANTRY_WEAPONS].map(w => [w.id, w])
);
